/* eslint no-console:0 */

import { Application } from "@hotwired/stimulus"
import { registerControllers } from 'stimulus-vite-helpers'

const application = Application.start()
const controllers = import.meta.glob('../**/*_controller.js', { eager: true })
registerControllers(application, controllers)

// Import and register all TailwindCSS Components
import { Dropdown } from "tailwindcss-stimulus-components"
application.register('dropdown', Dropdown)

// Set up I18n-js
import { i18n } from "../i18n";
window.i18n = i18n

// Set up Hotwired and Turbo
import "@hotwired/turbo-rails"

// Register custom Turbo Stream actions
import { StreamActions } from "@hotwired/turbo"
StreamActions.redirect_to = function () {
  Turbo.visit(this.getAttribute("url"))
}

// Register the Service Worker
if (navigator.serviceWorker) {
  navigator.serviceWorker.register('/serviceworker.js', { scope: './' })
    .catch(function (err) {
      console.warn('Service Worker registration failed: ', err)
    })
}
